import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/regions/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listRegions, updateRegion } from "../../../redux/actions/table/superadmin/regions";
import EditRegionForm from "../../../forms/superadmin/regions/EditRegionForm";
import { listLocalization } from "../../../redux/actions/localization";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateRegion(formData.id, _.omit(formData, ['id'])).then(() => {
                listRegions();

                this.props.readAction(formData.id);

                listLocalization();

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditRegionForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
